import React from 'react'
import { View } from 'react-native'

import { useForm } from 'react-hook-form'

import { useCalculateEMI } from '../../api/calculateEMI/hooks/useCalculateEMI'
import { EmiCalculatedValues } from './emiCalculatedValues'
import Form from './form'

export const EmiCalculator = () => {
  const { mutate, isLoading, data, isError, isSuccess } = useCalculateEMI()

  const form = useForm({
    mode: 'onTouched',
    defaultValues: {
      amount: undefined,
      tenure: undefined,
    },
  })

  return (
    <View className="flex-1">
      <EmiCalculatedValues
        isLoading={isLoading}
        emi={isLoading || isError ? undefined : data?.emi}
        interestRate={isLoading || isError ? undefined : data?.rateOfInterest}
        isValid={form?.formState?.isValid}
      />
      <Form
        calculateEMI={mutate}
        calculateEMISuccess={isSuccess}
        calculateEMILoading={isLoading}
        form={form}
      />
    </View>
  )
}
